/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutBaggageAllowance
 */
export interface FlightCheckoutBaggageAllowance {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutBaggageAllowance
     */
    type: FlightCheckoutBaggageAllowanceTypeEnum;
    /**
     *
     * @type {number}
     * @memberof FlightCheckoutBaggageAllowance
     */
    quantity: number;
    /**
     *
     * @type {number}
     * @memberof FlightCheckoutBaggageAllowance
     */
    weight?: number | null;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutBaggageAllowance
     */
    weightUnit?: FlightCheckoutBaggageAllowanceWeightUnitEnum | null;
}


/**
 * @export
 */
export const FlightCheckoutBaggageAllowanceTypeEnum = {
    CarryOn: 'carry_on',
    Checked: 'checked',
    PersonalItem: 'personal_item'
} as const;
export type FlightCheckoutBaggageAllowanceTypeEnum = typeof FlightCheckoutBaggageAllowanceTypeEnum[keyof typeof FlightCheckoutBaggageAllowanceTypeEnum];

/**
 * @export
 */
export const FlightCheckoutBaggageAllowanceWeightUnitEnum = {
    Kg: 'kg',
    Lb: 'lb'
} as const;
export type FlightCheckoutBaggageAllowanceWeightUnitEnum = typeof FlightCheckoutBaggageAllowanceWeightUnitEnum[keyof typeof FlightCheckoutBaggageAllowanceWeightUnitEnum];


/**
 * Check if a given object implements the FlightCheckoutBaggageAllowance interface.
 */
export function instanceOfFlightCheckoutBaggageAllowance(value: object): value is FlightCheckoutBaggageAllowance {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function FlightCheckoutBaggageAllowanceFromJSON(json: any): FlightCheckoutBaggageAllowance {
    return FlightCheckoutBaggageAllowanceFromJSONTyped(json, false);
}

export function FlightCheckoutBaggageAllowanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutBaggageAllowance {
    if (json == null) {
        return json;
    }
    return {

        'type': json['type'],
        'quantity': json['quantity'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'weightUnit': json['weight_unit'] == null ? undefined : json['weight_unit'],
    };
}

export function FlightCheckoutBaggageAllowanceToJSON(json: any): FlightCheckoutBaggageAllowance {
    return FlightCheckoutBaggageAllowanceToJSONTyped(json, false);
}

export function FlightCheckoutBaggageAllowanceToJSONTyped(value?: FlightCheckoutBaggageAllowance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'type': value['type'],
        'quantity': value['quantity'],
        'weight': value['weight'],
        'weight_unit': value['weightUnit'],
    };
}
